import type { ReactNode } from "react";

interface DataTableCardProps {
	/** Filters, search, bulk actions — rendered in the toolbar strip. */
	toolbar?: ReactNode;
	/** Right side of the toolbar, usually a result count. */
	toolbarExtra?: ReactNode;
	children: ReactNode;
}

/**
 * Wraps a table in a hairline panel with an optional toolbar strip, so every
 * list page in the app shares one silhouette.
 */
export function DataTableCard({ toolbar, toolbarExtra, children }: DataTableCardProps) {
	return (
		<div className="overflow-hidden rounded-xl border border-[var(--c-border)] bg-[var(--c-surface)]">
			{toolbar || toolbarExtra ? (
				<div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-[var(--c-border-subtle)] p-3 sm:px-4 sm:py-3">
					<div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">{toolbar}</div>
					{toolbarExtra ? (
						<div className="text-xs text-[var(--c-text-muted)] self-end sm:self-auto">
							{toolbarExtra}
						</div>
					) : null}
				</div>
			) : null}
			{children}
		</div>
	);
}
